import { useState } from 'react'

import { ROUTES } from '@/shared/config'
import { PrimaryButton } from '@/shared/ui'
import { Form, Modal, Radio } from 'antd'
import { useNavigate } from 'react-router-dom'

type FormType = 'album' | 'albumCollection'

type collectionTypeChoiceModalProps = {
  open: boolean
  onCancel: () => void
}

export const CollectionTypeChoiceModal = ({
  open,
  onCancel,
}: collectionTypeChoiceModalProps) => {
  const [selectedForm, setSelectedForm] = useState<FormType>('album')
  const navigate = useNavigate()

  const handleCreate = () => {
    if (selectedForm === 'album') {
      void navigate(ROUTES.COLLECTIONS.CREATE_ALBUM)
    } else {
      void navigate(ROUTES.COLLECTIONS.CREATE_ALBUM_COLLECTION)
    }
    open = false
  }

  return (
    <Modal
      open={open}
      title="Создание записи"
      footer={[
        <PrimaryButton key="create" onClick={handleCreate}>
          Создать
        </PrimaryButton>,
      ]}
      maskClosable={false}
      centered
      onCancel={onCancel}
    >
      <Form.Item label="Выберите тип записи" layout="vertical">
        <Radio.Group
          onChange={(e) => setSelectedForm(e.target.value)}
          value={selectedForm}
        >
          <Radio value="album">Альбом</Radio>
          <Radio value="albumCollection">Выпуск</Radio>
        </Radio.Group>
      </Form.Item>
    </Modal>
  )
}
